"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _qs = _interopRequireDefault(require("qs"));
var _default = exports.default = function _default(name) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    search = ""
  } = window.location;
  let params = _qs.default.parse(search.substr(1));
  if (options.caseSensitive === false) {
    name = name.toUpperCase();
    params = getUpperCasedAttr(params, options === null || options === void 0 ? void 0 : options.firstParamOnly);
  }
  if (options.firstParamOnly && Array.isArray(params[name])) {
    return params[name][0];
  }
  return params[name] ? params[name] : "";
};
const getUpperCasedAttr = function (params) {
  let firstParamOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let updatedObj;
  if (firstParamOnly) {
    let savedKeys = [];
    updatedObj = Object.keys(params).reduce(function (acc, key) {
      let found = savedKeys.find(function (element) {
        return element.toUpperCase() == key.toUpperCase();
      });
      savedKeys.push(key);
      if (!found) acc[key.toUpperCase()] = params[key];
      return acc;
    }, {});
  } else {
    updatedObj = Object.keys(params).reduce(function (acc, key) {
      acc[key.toUpperCase()] = params[key];
      return acc;
    }, {});
  }
  return updatedObj;
};